<template>
    <div v-if="orderDetail" class="order-detail-page">
        <div>
            <div class="order-title">
                <div class="order-title-text">订单明细</div>
            </div>
            <div class="order-cell">
                <div class="order-cell-title">订单号：</div>
                <div class="order-cell-text">{{ orderDetail.id }}</div>
            </div>
            <div class="order-cell">
                <div class="order-cell-title">支付时间：</div>
                <div class="order-cell-text">{{ orderDetail.created_at }}</div>
            </div>
            <div class="order-cell">
                <div class="order-cell-title">当前状态：</div>
                <template v-if="orderDetail.status === 0">
                    <div class="order-cell-text" style="color: #6b4d9a">待生产</div>
                </template>
                <template v-if="orderDetail.status === 1">
                    <div class="order-cell-text" style="color: #6b4d9a">生产中</div>
                </template>
                <template v-if="orderDetail.status === 2">
                    <div class="order-cell-text" style="color: #6b4d9a">待派工</div>
                </template>
                <template v-if="orderDetail.status === 3">
                    <div class="order-cell-text" style="color: #6b4d9a">已派工</div>
                </template>
                <template v-if="orderDetail.status === 4">
                    <div class="order-cell-text" style="color: #6b4d9a">已完成</div>
                </template>
            </div>
            <div class="order-cell">
                <div class="order-cell-title">客户姓名：</div>
                <div class="order-cell-text">
                    {{ orderDetail.customer_name }}
                </div>
            </div>
            <div class="order-cell">
                <div class="order-cell-title">客户地址：</div>
                <div class="order-cell-text">
                    {{ orderDetail.address }}
                </div>
            </div>
            <div class="order-cell">
                <div class="order-cell-title">反馈备注：</div>
                <div class="order-cell-text">
                    {{ orderDetail.remarks ? orderDetail.remarks : "暂无" }}
                </div>
            </div>
        </div>
        <div class="copy">
            <van-button
                class="back-button"
                color="#6b4d9a"
                @click="copyToClipboard(`https://dgerp.demo.qoomoe.com/order/${orderDetail.id}/print`)"
            >
                点击复制/导出打印链接
            </van-button>
        </div>
        <div class="order-detail">
            <div class="order-detail-cell">
                <div class="order-detail-cell-left">
                    <div class="order-detail-cell-left-title">订单详情</div>
                    <div v-if="orderDetail.goods_data && Array.isArray(orderDetail.goods_data)">
                        <div class="order-detail-cell-left-number">共{{ orderDetail.goods_data.length }}件</div>
                    </div>
                </div>
                <div class="order-detail-cell-totalprice">共计：{{ orderDetail.total_price }}</div>
            </div>
        </div>
        <div v-for="(item, index) in orderDetail.goods_data" :key="index">
            <div class="good-detail">
                <div>
                    <van-cell center>
                        <template #icon>
                            <img class="good-detail-pic" :src="item.images" />
                        </template>
                        <template #title>
                            <div class="good-detail-title">{{ item.title }}#{{ item.sub_title }}</div>
                        </template>
                        <template #label>
                            <div class="good-detail-label">
                                <div>图片色</div>
                                <div class="good-detail-label-count">数量 x {{ item.count }}</div>
                            </div>
                        </template>
                        <template v-slot="value">
                            <div class="good-detail-value">小计：{{ item.total_price }}</div>
                        </template>
                    </van-cell>
                </div>
            </div>
        </div>
        <div class="careful">
            <div class="careful-title">注意事项：</div>
            <div class="careful-bottom">
                <div class="careful-text">1.质量验收标准以双方确认样品为准;</div>
                <div class="careful-text">2.以上商品不含税;</div>
                <div class="careful-text">3.订货后不得退款退货;</div>
                <div class="careful-text">
                    所有家具，均为实物拍摄，但因显示器光源不同及工生产批次不同，到货实物有细微色差均属于正常现象。如有改色、改皮、换款等情况，照片色板允许与实物有15%的色差，选择时慎重考虑，请知悉!
                </div>
                <div class="careful-text">
                    4.家具行业允许的尺寸误差是大于或小于5cm，沙发属于软体家具误差不能超过10cm
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// 引入接口
import { GET_ORDERS_DETAIL } from "@/api/dataProvider.js";

export default {
    name: "OrderDetail",
    data() {
        return {
            orderDetail: {}
        };
    },
    mounted() {
        this.getOrderDetail();
    },
    methods: {
        // 获取订单详情
        getOrderDetail() {
            GET_ORDERS_DETAIL(
                {
                    id: this.$route.params.id
                },
                (res) => {
                    this.orderDetail = res.data.data.data;
                }
            );
        },
        //复制弹窗
        copyToClipboard(text) {
            this.$copyText(text).then(() => {
                this.$notify({ type: "success", message: "链接复制成功，请到浏览器进行打印操作" });
            });
        }
    }
};
</script>

<style lang="scss">
.order-detail-page {
    padding: 0 0 50px 0;
    .order-title {
        margin: 30px 0;
        text-align: center;
        .order-title-text {
            display: inline-block;
            padding: 0 10px;
            border-left: 2px solid #6b4d9a;
            border-right: 2px solid #6b4d9a;
            font-size: 16px;
            font-weight: 600;
            color: #333333;
        }
    }
    .order-cell {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 20px;
        .order-cell-title {
            font-size: 14px;
            font-weight: 600;
            color: #333333;
        }
        .order-cell-text {
            font-size: 14px;
            font-weight: 600;
            color: #333333;
        }
    }
    .copy {
        padding: 20px;
        .back-button {
            width: 100%;
        }
    }
    .order-detail {
        .order-detail-cell {
            display: flex;
            justify-content: space-between;
            align-items: center;

            padding: 20px;
            font-size: 14px;
            font-weight: 600;
            .order-detail-cell-left {
                display: flex;
                .order-detail-cell-left-title {
                    font-size: 15px;
                }
                .order-detail-cell-left-number {
                    margin-top: 6px;
                    margin-left: 10px;
                    font-size: 10px;
                    color: #999999;
                }
            }
            .order-detail-cell-totalprice {
                margin-left: auto;
                color: #6b4d9a;
            }
        }
    }
    .good-detail {
        .good-detail-pic {
            width: 70px;
            height: 52px;
            border-radius: 5px;
            margin-right: 10px;
        }
        .good-detail-title {
            width: 190px;
            font-weight: bold;
            font-size: 12px;
            line-height: 16px;
        }
        .good-detail-label {
            display: flex;
            font-size: 10px;
            color: #999999;
            .good-detail-label-count {
                margin-left: 10px;
            }
        }
        .good-detail-value {
            color: #6b4d9a;
            font-size: 11px;
        }
    }
    .careful {
        padding: 20px;
        font-size: 12px;
        .careful-title {
            margin-bottom: 4px;
            color: #999999;
        }
        .careful-bottom {
            width: 300px;
            line-height: 17px;
            .careful-text {
            }
        }
    }
}
</style>
